import './style.css';

import { Checkbox, FormControlLabel } from '@material-ui/core';

import _ from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';

@observer
class CheckList extends React.Component {
  render() {
    const { src, displayMember, renderLabel, value, valueMember } = this.props;
    const values = value.map((x) => x[valueMember] || x);
    const content = src.map((x, idx) => {
      const name = x[displayMember] || x;
      const itemValue = x[valueMember] || name;
      const isChecked = values.includes(itemValue) || values.includes(name);
      return (
        <li key={idx}>
          <FormControlLabel
            label={renderLabel ? renderLabel(x) : name}
            control={
              <Checkbox checked={!!isChecked} onChange={this.onCheck.bind(this, itemValue)} />
            }
          />
        </li>
      );
    });

    return <ul className="bz-checklist">{content}</ul>;
  }

  onCheck(itemValue, e) {
    const { onChange, valueMember, value } = this.props;
    let current = value.map((x) => x[valueMember] || x);
    if (e.target.checked) {
      current.push(itemValue);
    } else {
      current = current.filter((f) => f !== itemValue);
    }
    onChange(_.compact(current));
  }
}

CheckList.defaultProps = {
  src: [],
  value: [],
  onChange: () => {},
  valueMember: 'path',
  displayMember: 'name'
};

export default CheckList;
